module.exports = __webpack_public_path__ + "img/jiangpin.419706b6.png";